import { useContext } from 'react';
import { agendContasContextData } from '../types';
import { agendContasContext } from '../Context';

export const useAgendContas = (): agendContasContextData =>
  useContext(agendContasContext);
